import React, { useEffect, useRef, useState, useMemo } from "react";
import { Row, Col, Button, Checkbox, Input, Card, Switch, Typography, message, Select, Spin,Grid } from "antd";
import { ArrowLeftOutlined, DownCircleOutlined, DownOutlined, SearchOutlined } from "@ant-design/icons";
import { EnvironmentOutlined } from "@ant-design/icons";
import { genericApiCall, spacerData } from "./CommonApiCallCalender";
import dayjs from "dayjs";
import moment from "moment";
import { ColorCode } from "../Common/ColorCode";
import './ClinicBooking.css';
import useDebounce from "../Common/useDebounce";
import ClinicMap from "./ClinicMap";
import { capitalizeWords, filterByNonGpProductId } from "../Common/CommonFunction";
import "./BookingForm.css"
import location from "../../Assets/location.png"
import locationHover from "../../Assets/locationHover.png"
import AppointmentInfo from "../AppointmentInfo/AppointmentInfo";
// const { Title } = Typography
const { Text, Title } = Typography;
const timeSlots = [
    "08:00 - 10:00",
    "10:00 - 12:00",
    "12:00 - 14:00",
    "14:00 - 16:00",
    "16:00 - 18:00",
    "18:00 - 20:00",
];

const days = [
    { day: "MON", date: "13" },
    { day: "TUE", date: "14" },
    { day: "WED", date: "15" },
    { day: "THU", date: "16" },
    { day: "FRI", date: "17" },
];
const { Option } = Select;

const ClinicBooking = (props) => {
    const locationPermission = localStorage.getItem('locationPermission')
    const initialClinicId = props?.clinicId ? String(props.clinicId) : null;
    // initialize selectedClinics only when a clinicId prop is provided
    const [selectedClinics, setSelectedClinics] = useState(() => (initialClinicId ? [initialClinicId] : []));
    
    const [selectedClinicsNew, setSelectedClinicsNew] = useState([]);
    // Fetch preferred clinics on mount
    useEffect(() => {
        async function fetchPreferredClinics() {
            setloading(true);
            try {
                // Determine product_category_id and product_id from props
                const productCategoryId = props?.showAppoinmentData?.clinic?.productCategory?.product_category_id;
                const productId = props?.showAppoinmentData?.non_gp_product_id || props?.showAppoinmentData?.clinic?.productCategory?.product_id;
                let data = { product_category_id: productCategoryId };
                if ((productCategoryId === 2 || productCategoryId === 3) && productId) {
                    data.product_id = productId;
                }
                // Add duration_id, gender, and languages if available
                if (props.showAppoinmentData?.duration) {
                    data.duration_id = props.showAppoinmentData.duration;
                }
                if (props?.prefanceData?.gender && props?.prefanceData?.gender !== 'no_preference') {
                    data.gender = props?.prefanceData?.gender;
                }
                if(props.data.clinic?.latitude && props.data.clinic?.longitude){
                    data.lat = props.data.clinic?.latitude
                    data.lng = props.data.clinic?.longitude
                }
                if (props?.prefanceData?.language) {
                    let langId = props?.prefanceData?.language;
                    if (typeof langId === 'object' && langId.value) {
                        langId = langId.value;
                    }
                    data.languages = [langId];
                }
                const csrRoomData = await genericApiCall('preferred-clinics', data, null, false);
                if (csrRoomData?.data?.data) {
                    setSelectedClinicsNew(csrRoomData.data.data);
                } else {
                    setSelectedClinicsNew([]);
                }
            } catch (error) {
                setSelectedClinicsNew([]);
                messageApi.error({ type: 'error', content: 'Failed to load clinics.' });
            }
            setloading(false);
        }
        fetchPreferredClinics();
    }, []);

    // If a clinicId prop is passed, populate selectedClinicsNew and clickedClinicIdItem
    useEffect(() => {
        if (!props?.clinicId) return;
        try {
            const idStr = String(props.clinicId);
            let clinicObj = null;
            if (props.data?.allClinicData && Array.isArray(props.data.allClinicData.data)) {
                clinicObj = props.data.allClinicData.data.find(c => String(c.id ?? c.clinic_id) === idStr) || null;
            }
            if (!clinicObj && props.data?.allClinicDataByID && props.data.allClinicDataByID[idStr]) {
                clinicObj = props.data.allClinicDataByID[idStr];
            }
            if (clinicObj) {
                setSelectedClinicsNew([clinicObj]);
                setSelectedClinics(prev => (prev && prev.includes(idStr) ? prev : [...(prev || []), idStr]));
                setClickedClinicItem(clinicObj);
            }
        } catch (e) {
            // ignore
        }
    }, [props?.clinicId, props?.data]);
    const [messageApi, contextHolder] = message.useMessage();
    const [locationPermissionData, setlocationPermissionData] = useState(locationPermission);
    const [selectedSlots, setSelectedSlots] = useState([]);
    const [showPreferredTime, setshowPreferredTime] = useState(false);
    const [loading, setloading] = useState(false);
    const [loadingLocation, setloadingLocation] = useState(false);
    const [searchBylocationName, setsearchBylocationName] = useState('');
    const [searchBylocationOption, setsearchBylocationOption] = useState([]);
    const [showPreferredTimeSlot, setshowPreferredTimeSlot] = useState([]);
    const [selectedClinicsStartAndEndTime, setselectedClinicsStartAndEndTime] = useState([]);
    const [selectedMonth, setselectedMonth] = useState(null);
    const [metaData, setmetaData] = useState(null);
    const debouncedInputValue = useDebounce(selectedClinicsStartAndEndTime, 1500);
    const [loadingTime, setloadingTime] = useState(false);
    const debouncedInputValueData = useDebounce(searchBylocationName, 800);
    const [cordData, setcordData] = useState([]);
    const [clickedClinicIdItem, setClickedClinicItem] = useState(null); // for initial only click 
    const [clickContinue, setClickContinue] = useState(false); // for continue button
    const [isHovered, setIsHovered] = useState(false);
     const [buttonActive,setButtonActive] = useState(true);
      const [width, setWidth] = useState(0);
          const elementRefs = useRef([]);
          const elementwidthRef = useRef(null);

          const buttonStyle = {
    width: "181px",
    height: "40px",
    cursor: "pointer",
    backgroundColor: isHovered ? "#008385":"white" , // darker on hover
    color:isHovered ?"#fff ": "#008385",
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: "16px",
    margin: "auto",
    display: "flex",
    gap: "8px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "10px",
    transition: "background-color 0.3s ease", // optional: smooth hover
    border:"1px solid #008385"
  };

  function stripHtmlTags(htmlString) {
  if (!htmlString) return '';
  return htmlString.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
}

 useEffect(() => {
      if (props?.check) {
        // console.log('props?.check', props?.check)
        // setSelectedClinics([])
        setSelectedSlots([])
        setselectedClinicsStartAndEndTime([])
        setButtonActive(true)
      }
  },[props?.check])
 
    function getProductName(id) {
        let products;
      
        // Try to load from localStorage and parse to object
        const stored = localStorage.getItem('nongroupproductid');
        if (stored) {
          try {
            products = JSON.parse(stored); // parse string to object
          } catch (e) {
            console.error("Invalid JSON in localStorage");
            products = {}; // fallback to empty object on error
          }
        } else {
          // Fallback if nothing in localStorage
          products = {
            201: "Vital",
            202: "Bronze",
            203: "Silver",
            204: "Gold",
            205: "Platinum",
            4: "Vital (15 minutes)",
            5: "Bronze (60 minutes)",
            6: "Gold (90 minutes)",
            7: "Silver (75min)",
            10: "Platinum",
            18: "r888",
            20: "r888178",
            22: "Diamond"
          };
        }
      
        // console.log("productsproductsproducts", products, typeof products);
        return products[id] || `Product ${id}`;
      }
      
    
      const { useBreakpoint } = Grid;
        const screens = useBreakpoint();
    
    const nextWeekOptions = Array.from({ length: 7 }, (_, i) => {
        const date = dayjs().add(i, 'day');
        return {
            label: date.format("MMM 'DD"), // e.g., "Apr '25"
            value: date.format("YYYY-MM-DD"), // keep full date value
        };
    });
    useEffect(() => {
        window.scrollTo(0, 0);
        // console.log('props?.metaData?.selectedSlots', props ,props?.metaData)
        if (props?.metaData?.selectedClinics) {
            // for (let index = 0; index < props?.metaData?.selectedClinics.length; index++) {
            //     const e={target:{value:props?.metaData?.selectedClinics[index],checked:true}}
            //     handleClinicChange(e)
            // }
            // setSelectedClinics(['40', '39', '38'])
            // normalize incoming clinic ids to strings so checkbox checks work
            try {
                const normalized = Array.isArray(props.metaData.selectedClinics)
                    ? props.metaData.selectedClinics.map(id => String(id))
                    : [String(props.metaData.selectedClinics)];
                setSelectedClinics(normalized);
            } catch (e) {
                setSelectedClinics(props?.metaData?.selectedClinics);
            }
        }
        if (props?.metaData?.selectedClinics && props?.metaData?.selectedSlots) { 
            // appointmentClinicSelection(null, 1, true)
            
            for (let index = 0; index < props?.metaData?.selectedSlots.length; index++) {
                toggleSlot(`${props?.metaData?.selectedSlots[index]?.date}${props?.metaData?.selectedSlots[index]?.start_time}-${props?.metaData?.selectedSlots[index]?.end_time}`, props?.metaData?.selectedSlots[index]?.info, props?.metaData?.selectedSlots[index]?.date)
            }
            // setSelectedSlots(props?.metaData?.selectedSlots)
            setshowPreferredTime(true)
        }
        
    },[])
     useEffect(() => {
        // console.log('elementwidthRef', elementwidthRef)
        const element = elementwidthRef?.current;
        if (!element) return;
    
        const observer = new ResizeObserver(() => {
          const visibleWidth = element?.getBoundingClientRect().width;
          const contentWidth = element?.scrollWidth;
          setWidth(visibleWidth -50);
        //   console.log('Width changed. Visible:', visibleWidth, 'Content:', contentWidth);
        });
        observer?.observe(element);
        return () => observer?.disconnect();
        }, [elementwidthRef]);    
    
        useEffect(() => {
            // console.log('check', showPreferredTimeSlot ,elementRefs?.current ,width ,elementRefs.current.length ,width % 93)
            if (width % 93 >=80 ||width % 93 <=15 ) {
                            elementRefs?.current?.forEach((ela) => {
                                ela?.scrollTo({
                                    left: 33,
                                    behavior: 'smooth'
                                });
                                    // console.log('ela', ela)
                            });
                        }
                        else{
                            elementRefs?.current?.forEach((ela) => {
                                ela?.scrollTo({
                                    left: 0,
                                    behavior: 'smooth'
                                });
                                    // console.log('ela', ela)
                            });
                        }
        }, [showPreferredTimeSlot,width]);

    useEffect(() => {
        if (selectedClinics.length > 0 && props?.metaData?.selectedClinics?.length > 0) {
        appointmentClinicSelection(null, 1, true);
    }
}, [selectedClinics]);

    useEffect(() => {
        // console.log('::::::useEffect ClinicBooking  debouncedInputValue:::::::', selectedMonth)
        if (selectedMonth) {
            appointmentClinicSelection(null, 1, true)
        }
    }, [selectedMonth])
    useEffect(() => {
        if (clickContinue ) {
            appointmentClinicSelection(null, 1, true)
        }
    }, [clickContinue,selectedClinics])

    useEffect(() => {
        // console.log('::::::useEffect ClinicBooking  debouncedInputValue:::::::', { debouncedInputValue, props, selectedClinics })
        if (debouncedInputValue) {
            let payloadPassNew = {
                selectedClinics: selectedClinics,
                selectedSlots: debouncedInputValue, 
                type: 'TIME',
            }
            // console.log('payloadPassNew:::', payloadPassNew)
            props.callback(payloadPassNew, 'PreferredTimeclinic');
        }

    }, [debouncedInputValue])
    useEffect(() => {
        // console.log('::::::useEffect ClinicBooking  debouncedInputValue:::::::', debouncedInputValueData)
        if (debouncedInputValueData) {
            getAllSearchData(debouncedInputValueData)
        }
    }, [debouncedInputValueData])

    const getAllSearchData = async (payload) => {
        setloadingLocation(true)
        let data = {
            "input": payload
        }

        let csrRoomData 
        if(props?.data?.isProtected === false ){
            csrRoomData = await await spacerData('get-address', data, null, false)
        }else {
            csrRoomData = await spacerData('get-address', data)
        }
        if (csrRoomData?.data?.data) {
            let tempData = []
            csrRoomData?.data?.data.map(a => {
                tempData.push({
                    value: `${a.lat}::${a.lng}`,
                    label: a.address,
                })
            })
            // console.log('get-address', csrRoomData?.data?.data)
            setsearchBylocationOption(tempData)
            setloadingLocation(false)
        }
    }
    const handleClinicChange = (e) => {
        const value = e.target.value;
        const checked = e.target.checked;
        let data
        setSelectedClinics(prev => {
            if (checked) {
                if (prev.length >= 3) {
                    messageApi.error({
                        type: 'error',
                        content: 'You can only select up to 3 options.',
                    });
                    data = prev
                    return prev;
                } else {
                    data = [...prev, value];
                    return [...prev, value];
                }
            } else {
                data = prev.filter(item => item !== value);
                return prev.filter(item => item !== value);
            }
        });
        // if checked, move the clinic data to top and set clickedClinicIdItem
        if (checked) {
            try {
                const idStr = String(value);
                const clinicObj = props.data?.allClinicDataByID?.[idStr] || (props.data?.allClinicData?.data || []).find(c => String(c.id ?? c.clinic_id) === idStr);
                if (clinicObj) {
                    setSelectedClinicsNew(prev => {
                        if (!prev || !prev.length) return [clinicObj];
                        const others = prev.filter(c => String(c.id ?? c.clinic_id) !== idStr);
                        return [clinicObj, ...others];
                    });
                    setClickedClinicItem(clinicObj);
                }
            } catch (e) {
                // ignore
            }
        }
        // console.log('selectedClinics', data)
        let tempData = []
        if (data && data.length > 0) {
            data.map(id => {
                if (props.data?.allClinicDataByID[id]?.latitude && props.data?.allClinicDataByID[id]?.longitude) {
                    tempData.push({
                        id: id,
                        name: props.data?.allClinicDataByID[id].name ?? 'No data',
                        data: [props.data?.allClinicDataByID[id].latitude, props.data?.allClinicDataByID[id].longitude]
                    })

                }
            })
        }
        setcordData(tempData)
        // console.log('tempData', tempData)
    };
    const appointmentClinicSelection = async (id, pageNumber = 1, reset) => {
        setClickContinue(true)
        setloading(true)
        setloadingTime(true)
        if (selectedClinics.length > 0) {
            // console.log('selectedClinics gender', selectedClinics, props.showAppoinmentData)
            let data = {
                "clinic_ids": selectedClinics ?? [40],
            }
            if (props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 2 || props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 3) {
                if (!props.showAppoinmentData?.non_gp_product_id || !props?.showAppoinmentData?.clinic?.productCategory?.product_id ) {
                    messageApi.error({
                        type: 'error',
                        content: 'Please select product category first.',
                    });
                }
                if(props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 2 || props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 3){
                data = {
                    ...data,
                    "product_id":props.showAppoinmentData?.non_gp_product_id ?? props.showAppoinmentData.clinic.productCategory.product_id,
                    
                    "product_category_id": props.showAppoinmentData?.clinic?.productCategory?.product_category_id ?? 2,
                }
                }
            }
            if (props.showAppoinmentData?.gender && props.showAppoinmentData?.gender != 'no_preference') {
                data = {
                    ...data,
                    "gender": props.showAppoinmentData?.gender ?? undefined,
                }
            }
            if (props.showAppoinmentData?.language) {
                let id = props.showAppoinmentData?.language
                if (props.showAppoinmentData?.language && props.showAppoinmentData?.language?.label && props.showAppoinmentData?.language?.label == 'English') {
                    id = 1
                }

                data = {
                    ...data,
                    "languages": [id] ?? undefined,
                }
            }
               if (props?.prefanceData?.gender && props?.prefanceData?.gender !== 'no_preference') {
             data = {
                ...data,
                "gender": props?.prefanceData?.gender
            }
            }
            if (props?.prefanceData?.language) {
                let langId = props?.prefanceData?.language;
                if (typeof langId === 'object' && langId.value) {
                    langId = langId.value;
                }
                data = {
                    ...data,
                    "languages": [langId]
                }
            }
            if (props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 1) {
                data = {
                    ...data,
                    "duration_id": props.showAppoinmentData?.duration ?? 1,
                    "product_category_id": props.showAppoinmentData?.clinic?.productCategory?.product_category_id ?? 1,
                }
            }
            //  "languages" : [1],
            if (selectedMonth) {
                data = {
                    ...data,
                    "month": selectedMonth ?? 1,
                }
            }
            let api = `preferred-time/page/${pageNumber ? pageNumber : 1}`
            let csrRoomData 
            if(props?.data?.isProtected === false ){
                csrRoomData = await spacerData(api, data, null, false)
            }else {
                csrRoomData = await spacerData(api, data)
            }
            // console.log('preferred-time', csrRoomData)
            if (csrRoomData?.data?.data) {
                setmetaData(csrRoomData.data.meta)
                if (reset) {
                    setshowPreferredTimeSlot(csrRoomData?.data?.data)
                } else {
                    setshowPreferredTimeSlot(pre => ({
                        ...pre,
                        ...csrRoomData.data.data
                    }))
                }

                setshowPreferredTime(true);
            }
            setloadingTime(false)
        } else {
            messageApi.error({
                type: 'error',
                content: 'Please select at least one clinic.',
            });
            setshowPreferredTime(false);
        }
        setloading(false)
    };
    const checkLocationPermission = () => {
        if (!navigator.geolocation) {
            messageApi.error({
                type: 'error',
                content: 'Geolocation is not supported by this browser.',
            });
            return;
        }

        navigator.permissions
            .query({ name: 'geolocation' })
            .then((result) => {
                if (result.state === 'denied') {
                    messageApi.error({
                        type: 'error',
                        content: 'Location permission is denied. Please enable it in your browser settings and reload the page.',
                    });
                } else {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            
                            getAllDataBYApi({ latitude: position.coords.latitude, longitude: position.coords.longitude });
                        },
                        (error) => {
                            messageApi.error({
                                type: 'error',
                                content: 'Unable to retrieve location: ' + error.message,
                            });
                        }
                    );
                }
            })
            .catch((err) => {
                messageApi.error({
                    type: 'error',
                    content: 'Could not check location permission: ' + err.message,
                });
            });
    };

    const getAllDataBYApi = async (coords) => {
        let data = {
            "lat": coords.latitude,
            "lng": coords.longitude,
        }
        if (props?.showAppoinmentData?.language) {
            if (props.showAppoinmentData.language && props.showAppoinmentData.language.label) {
                data = {
                    ...data,
                    "languages": [props.showAppoinmentData.language.value ?? 1]
                }
            } else {
                data = {
                    ...data,
                    "languages": [props.showAppoinmentData.language ?? 1]
                }
            }
            if (props?.showAppoinmentData?.gender && props.showAppoinmentData?.gender != 'no_preference') {
                data = {
                    ...data,
                    "gender": props.showAppoinmentData.gender,
                }
            }
        }
        if (props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 2 || props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 3) {
            data = {
                ...data,
                "product_id": Number(props.showAppoinmentData?.non_gp_product_id) ?? null,
                "product_category_id": props.showAppoinmentData?.clinic?.productCategory?.product_category_id ?? 2,
            }
        }
        if (props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 1) {
            data = {
                ...data,
                "duration_id": props.showAppoinmentData?.duration ?? 1,
                "product_category_id": props.showAppoinmentData?.clinic?.productCategory?.product_category_id ?? 1,
            }
        }
        if (props?.prefanceData?.gender && props?.prefanceData?.gender !== 'no_preference') {
             data = {
                ...data,
                "gender": props?.prefanceData?.gender
            }
        }
        if (props?.prefanceData?.language) {
            let langId = props?.prefanceData?.language;
            if (typeof langId === 'object' && langId.value) {
                langId = langId.value;
            }
            data = {
                ...data,
                "languages": [langId]
            }
        }
        
        
        let csrRoomData 
        if(props?.data?.isProtected === false ){
            csrRoomData = await genericApiCall('preferred-clinics', data, null , false)
        }else {
            csrRoomData = await genericApiCall('preferred-clinics', data)
        }
        if (csrRoomData?.data?.data && csrRoomData?.data?.data.length > 0) {
            setSelectedClinicsNew(csrRoomData?.data?.data)
        }
    }
    const ShowMapDistance = () => {
        return <Col   className="paddingLeft"  style={{overflow:"hidden",paddingRight:"0px"}}
         xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 12 }}
            xxl={{ span: 12 }}>
                <div style={{marginRight:"auto",}} className="widthOfTitle">
            <div style={{  margin: '25px  auto', background: "#00838540", padding: 10,color: '#008385',  }} className="textalign widthOfTitle">
                    {/* {capitalizeWords('Location details')}: */}
                    Location details:
            </div>
            {selectedClinics && selectedClinics.length>1 ? <div style={{ width:!screens.md ? "100vw ": 400, margin: 'auto' }}>
                <div style={{ borderRadius: "10px", marginTop: "30px" ,display: 'flex', justifyContent: 'center' ,padding:"15px"}}>

                    <ClinicMap  widthAndheight={{ width:screens.lg || screens.xl ? 393 : screens.md ? 300 : "80vw", height:screens.lg || screens.xl ? 393 : screens.md ? 300 : "80vw" }} passData={{ cood: cordData, name: 'No data' }} />
                    
                </div>

            </div>
                : <div className="mapwidth"
                >
                        {/* {console.log("clickedClinicIdItem", clickedClinicIdItem,"\n selected clinics", selectedClinics)} */}
                    {clickedClinicIdItem && (
                            <div
                            className="notched-box"
                            style={{
                              marginTop: '30px',
                              borderRadius: '0',
                              border: '1px solid rgba(0, 131, 133, 1)',
                              padding: '14px',
                              maxWidth: '360px',
                              margin: '30px auto',
                              fontFamily: 'Arial, sans-serif',
                              color: '#000',
                              position: 'relative',
                            }}
                          >

                            <div
                              style={{
                                width: '181px',
                                height: '181px',
                                margin: '0 auto',
                              }}
                            >
                              <ClinicMap
                                widthAndheight={{ width: 181, height: 181 }}
                                passData={{
                                  cood: [
                                    {
                                      id: clickedClinicIdItem.id,
                                      name: clickedClinicIdItem.name,
                                      data: [
                                        parseFloat(clickedClinicIdItem.latitude),
                                        parseFloat(clickedClinicIdItem.longitude),
                                      ],
                                    },
                                  ],
                                  name: clickedClinicIdItem.position ?? 'No data',
                                }}
                              />
                            </div>
                      
                            <p
                              style={{
                                marginTop: '20px',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                              }}
                            >
                              {clickedClinicIdItem.name}
                            </p>
                      
                            <p
                              style={{
                                marginTop: '10px',
                                marginBottom: '10px',
                                textAlign: 'center',
                                fontSize: '14px',
                              }}
                            >
                              {clickedClinicIdItem.address}
                            </p>
                      
                            <div
                              style={{
                                textAlign: 'left',
                                fontSize: '12px',
                                lineHeight: '1.5',
                                color : "rgba(74, 74, 74, 1)",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: clickedClinicIdItem.clinic_website_description ?? '',
                              }}
                            />
                          </div>
                    )}
                </div>}

</div>
        </Col>
    }
    const months = Array.from({ length: 12 }, (_, i) => {
        const month = dayjs().add(i, 'month');
        return {
            value: month.format("MM"),  // e.g., "05"
            label: month.format("MMM YY"), // e.g., "May"
        };
    });
    const currentMonthValue = dayjs().format("MM");
    const handleSelect = (value) => {
        setselectedMonth(value)
        setSelectedSlots([])
        setselectedClinicsStartAndEndTime([])
    }
    const getLoadMoreData = () => {
        // 
        if (metaData && metaData.current_page && metaData.current_page != metaData.last_page) {
            // pass the next page number as the second argument and `true` for reset as third
            appointmentClinicSelection(null, 1 + parseInt(metaData.current_page), true)
            // setSelectedSlots([])
            setselectedClinicsStartAndEndTime([])
        }
    }
    const PreferredTime = () => {
        return <Col xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 12 }}
            xxl={{ span: 12 }}>
            <div style={{ maxWidth: "600px", marginTop: 25 , margin: "auto", padding: "20px",}}>
                <div
                    style={{
                        background: "#00838540",
                        padding: "10px",
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: "400",
                        color: '#008385'
                    }}
                >
                    Preferred time:
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 ,alignItems:"start"}}>
                    <div style={{ padding: "0px 0" }}>
                        <Select
                            value={selectedMonth}
                            onChange={handleSelect}
                            placeholder="Select Month"
                            bordered={false}
                            className="transparent-select antDesignDatepaddingRemove"
                            dropdownClassName="custom-month-dropdown"
                            dropdownStyle={{ backgroundColor: 'transparent', border: 'none' }}
                            >
                            {months.map((month) => (
                                <Option
                                key={month.value}
                                value={month.value}
                                style={{
                                    backgroundColor: 'transparent',
                                    color: '#000',
                                }}
                                >
                                {month.label}
                                </Option>
                            ))}
                            </Select>


                    </div>

                    <span  style={{color : "rgba(74, 74, 74, 1)"  , textAlign:"left"}}>
                        Choose the most convenient time slots to check the availability. You can
                        select more than one time slot.
                    </span>
                </div>

                <div style={{ marginTop: 20 }}>
                    {selectedSlots ? Object.keys(showPreferredTimeSlot)?.map((day, index) => (
                        <div style={{ textAlign: 'left' }} >
                            <div>{`${moment(day).format('ddd D').toUpperCase()} `}</div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                {showPreferredTimeSlot[day].map((slot) => {
                                    return <div
                                        key={`${day}-${slot.start_time}-${slot.end_time}-${index}`}
                                        type={selectedSlots.includes(slot) ? "primary" : "default"}
                                        onClick={() => toggleSlot(`${day}${slot.start_time}-${slot.end_time}`, slot, day)}
                                        style={{
                                            pointerEvents: slot.availablity_status ? 'auto' : 'none',
                                            minWidth: "100px",
                                            color: selectedSlots.includes(`${day}${slot.start_time}-${slot.end_time}`) ? "#008385" : "#000",
                                            color: slot.availablity_status == 0 ? '#4A4A4A80' : selectedSlots.includes(`${day}${slot.start_time}-${slot.end_time}`) ? "#008385" : "",
                                            marginTop: 9,
                                            cursor: 'pointer',
                                            padding: '5px 10px',
                                            lineHeight: 1
                                        }}
                                    >
                                        {`${slot.start_time}-${slot.end_time}`}
                                    </div>
                                })
                                }
                            </div>
                            <hr />
                        </div>
                    )) : loadingTime && <Spin className="custom-spinner" />}
                </div>
                {selectedSlots && showPreferredTimeSlot && Object.keys(showPreferredTimeSlot).length && metaData?.current_page != metaData?.last_page &&
                 <Button  onClick={getLoadMoreData} style={{ border: "none", width: 182, height: 40 }}>
                    Load More
                        <DownOutlined style={{ color: '#008385' }} />
                </Button>
                }
            </div>
        </Col>
    }
    const toggleSlot = async (slot, info, date) => {
        setButtonActive(false)
        let newTempData, timeSlots
        setSelectedSlots(prev => {
            if (!selectedSlots.includes(slot)) {
                if (prev.length >= 3) {
                    newTempData = prev
                    return prev;
                } else {
                    newTempData = [...prev, slot];
                    return [...prev, slot];
                }
            } else {
                newTempData = prev.filter(item => item !== slot);
                return prev.filter(item => item !== slot); // remove
            }
        });
        let updatedTimeSlots;
        const id = `${date}${info.start_time}`;
        const alreadySelected = selectedClinicsStartAndEndTime.some(item => item.id === id);

        if (!alreadySelected) {
            if (selectedClinicsStartAndEndTime.length >= 3) {
                messageApi.error({ type: 'error', content: 'Max 3 slots allowed.' });
                updatedTimeSlots = selectedClinicsStartAndEndTime;
            } else {
                const newEntry = {
                    id,
                    end_time: info.end_time,
                    start_time: info.start_time,
                    info,
                    clinic_id: info.available_clinics?.map(cid => cid.id) || [],
                    date
                };
                updatedTimeSlots = [...selectedClinicsStartAndEndTime, newEntry];
            }
        } else {
            updatedTimeSlots = selectedClinicsStartAndEndTime.filter(item => item.id !== id);
        }

        setselectedClinicsStartAndEndTime(updatedTimeSlots);
        return
        let payloadPass = {
            selectedSlots: timeSlots,
            date: date,
            info: info,
        }
        if (newTempData && newTempData.length > 0) {
            console.log('::::::payloadPass :::::::', { payloadPass, selectedClinicsStartAndEndTime })
            // props.callback(payloadPass, 'PreferredTime');
            // setSelectedSlots(payloadPass)
            // setselectedClinicsStartAndEndTime(payloadPass)
            checkLocationPermission()
        }
        let payloadPassNew = {
            selectedClinics: selectedClinics,
            selectedSlots: selectedClinicsStartAndEndTime,
            // date: date,
            // info: info,
            type: 'TIME'
        }
        console.log('data:::', selectedClinics)
        // props.callback(payloadPass, 'PreferredTime');
        props.callback(payloadPassNew, 'PreferredTimeclinic');
    }
    const onSelectLocation = (data) => {
        let dataPayload = data.split('::') ?? []
        if (dataPayload && dataPayload.length && dataPayload.length == 2) {
            getAllDataBYApi({ "latitude": dataPayload[0], "longitude": dataPayload[1], })
        }
    }
    // console.log('selectedClinicsStartAndEndTime', filterByNonGpProductId(props?.getAllHealthScreenData.getAllHealthScreenData.data, props?.showAppoinmentData.clinic?.non_gp_product_id))

    const handleClinicClick = (clinicItem) => {
        setClickedClinicItem(clinicItem);
        // move clicked clinic to top of the preferred list
        try {
            setSelectedClinicsNew(prev => {
                if (!prev || !prev.length) return [clinicItem];
                const idStr = String(clinicItem.id ?? clinicItem.clinic_id);
                const others = prev.filter(c => String(c.id ?? c.clinic_id) !== idStr);
                return [clinicItem, ...others];
            });
        } catch (e) {
            // ignore
        }
        // Do anything else you want with the full item
        // console.log("Selected Clinic:", clinicItem);
        // You can call a prop function or update a parent state here too
    };
    // derive displayed order: clicked clinic first, then selectedClinics (checked) in order, then remaining clinics
    const displayedClinics = useMemo(() => {
        const all = Array.isArray(selectedClinicsNew) ? selectedClinicsNew.slice() : [];
        const result = [];
        const seen = new Set();

        if (clickedClinicIdItem) {
            const idStr = String(clickedClinicIdItem.id ?? clickedClinicIdItem.clinic_id);
            const found = all.find(c => String(c.id ?? c.clinic_id) === idStr);
            if (found) {
                result.push(found);
                seen.add(idStr);
            }
        }

        // add checked clinics next (preserve order of selectedClinics array)
        if (Array.isArray(selectedClinics)) {
            selectedClinics.forEach(id => {
                const idStr = String(id);
                if (seen.has(idStr)) return;
                const found = all.find(c => String(c.id ?? c.clinic_id) === idStr);
                if (found) {
                    result.push(found);
                    seen.add(idStr);
                }
            });
        }

        // append the rest
        all.forEach(c => {
            const idStr = String(c.id ?? c.clinic_id);
            if (!seen.has(idStr)) {
                result.push(c);
                seen.add(idStr);
            }
        });

        return result;
    }, [selectedClinicsNew, selectedClinics, clickedClinicIdItem]);
    return (
        <>
            {contextHolder}
            {/* mexwidth */}
            <div style={{ display: 'grid', justifyContent: 'center'}}>
                <div style={{marginTop: screens.md ? "50px" : "0px"}} className="clinicTitle"
                 >
                    <Title style={{ margin: 0, fontSize: 20, color: '#008385', fontWeight:"400",paddingLeft:"5px" }} className="textalign">My booking:</Title>
                </div>
            </div>
            <div className="summuryCard generalConsultation"
            >
            {/* <span style={{ whiteSpace: "pre-line", textAlign: "center" }}>
            {
                // Title logic
                props?.showAppoinmentData.clinic?.productCategory?.title ||
                props?.showAppoinmentData.clinic?.clinic?.productCategory?.title || ''
            }
            {
                props?.showAppoinmentData.clinic?.productCategory?.product_category_id === 1 &&
                props.data?.durationObjectById?.[props?.showAppoinmentData?.duration] && (
                <>
                    {"\n"}
                    Duration: {props.data.durationObjectById[props.showAppoinmentData.duration].duration} minutes
                    {
                    props?.showAppoinmentData?.gender &&  props?.showAppoinmentData?.gender !== "no_preference"  ? (
                        <>
                        {" | "} Gender: { props.showAppoinmentData.gender.charAt(0).toUpperCase() + props.showAppoinmentData.gender.slice(1) } 
                        </>
                    ) : null
                    }
                    {
                    props?.showAppoinmentData?.selectedLanguage.label !== "English" ? (
                        <>
                        {" | "} Language: { props.showAppoinmentData.selectedLanguage.label.charAt(0).toUpperCase() + props.showAppoinmentData.selectedLanguage.label.slice(1) } 
                        </>
                    ) : null
                    }
                </>
                )
            }
                {
                    props?.showAppoinmentData.clinic?.productCategory?.product_category_id !== 1 &&
                    props?.showAppoinmentData?.gender && (
                    <>
                        {"\n"}Gender: {props.showAppoinmentData.gender}
                    </>
                    )
                }

                {
                    props?.showAppoinmentData.clinic?.productCategory?.product_category_id == 2 && (
                        <>
                       {" \n"} {getProductName(props?.showAppoinmentData?.non_gp_product_id)}
                       </>
                    )
                }
                </span> */}

                <AppointmentInfo
                productCategory={
                    props?.showAppoinmentData?.clinic?.productCategory || 
                    props?.showAppoinmentData?.clinic?.clinic?.productCategory
                }
                duration={
                    props.data?.durationObjectById?.[props?.showAppoinmentData?.duration]?.duration
                }
                gender={props?.showAppoinmentData?.gender}
                selectedLanguage={props?.showAppoinmentData?.selectedLanguage}
                nonGpProductId={
                    getProductName(
                    props?.showAppoinmentData?.non_gp_product_id || 
                    props?.showAppoinmentData?.clinic?.non_gp_product_id
                    )
                }
                //   price={100.00} // You'll need to pass the actual price prop if available
                />

            </div>
            <Row gutter={[16, 16]} style={{ marginTop:15 ,margin:"0px",rowGap:"0px"}}>
                <Col style={{padding:"0px" ,}} 
                className="paddingRight"
                 xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}>
                        <div style={{marginLeft:"auto"}} className="widthOfTitle">
                    <div style={{  margin: 'auto', background: "#00838540", padding: 10, marginTop:screens.md?25: 20,color: '#008385', }} className="textalign widthOfTitle">
                            Preferred clinic:
                    </div>
                    {/* search bar */}
                    <div className="searchWidth">
                        <div onClick={checkLocationPermission}  style={buttonStyle} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                                {!isHovered ? <img style={{width:"30px",height:"30px"}} src={locationHover} alt="BigCo Inc. logo"/> : <img  src={location} alt="BigCo Inc. logo"/>}
                                <div >  {locationPermissionData == 'granted' ? "Enabled" : "Enable location"}</div> 
                            </div>
                            <p style={{ textAlign: "center", margin: "6px 0" }}>OR</p> 
                        {searchBylocationOption && <Select
                            showSearch
                            placeholder="Select a location"
                            style={{ width: '100%',backgroundColor:"rgba(0, 131, 133, 0.25)",borderRadius:"50px" }}
                            onChange={(value) => onSelectLocation(value)}
                            onSearch={(value) => setsearchBylocationName(value)}
                            options={searchBylocationOption ?? ['nodata']}
                            filterOption={false}
                            loading={loadingLocation}
                        />}
                        <p style={{ marginTop: 15 }}>You can select up to 3 clinics</p>
                        <hr style={{marginBottom:"0"}} />
                        {
                    loading ? <Spin className="custom-spinner" /> :
                    displayedClinics?.map(a => {
                            if (a.clinic_id) {
                                a.id = a.clinic_id
                            }
                            const isSelected = clickedClinicIdItem?.id === a.id; // You need to store this state
                            return (
                                <>
                                    <div className="clinicFlexBox"  ref={elementwidthRef}
                                     >
                                        <div
                                            style={{
                                                flex: '1 1 80%',
                                                backgroundColor: isSelected ? 'rgba(0, 131, 133, 0.1)' : 'transparent',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                padding:"6px"
                                            }}
                                            onClick={() => handleClinicClick(a)}
                                        >
                                            <div style={{ flex: '1 1 50%' }}>
                                                <span>{a.name}</span>
                                            </div>
                                            <div style={{ flex: '1 1 30%' }}>
                                                {a.distance && <span>{a.distance}</span>}
                                            </div>
                                        
                                        <div style={{ 
                                              flex: '1 1 20%',
                                              textAlign: 'right',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'flex-end' // to push it to the right
                                              
                                         }}>
                                            <Checkbox 
                                                className="checkboxSelect" 
                                                style={{borderRadius:"0px",  marginRight: '6px'}} 
                                                checked={selectedClinics.includes(a.id.toString())} 
                                                value={a.id.toString()} onClick={handleClinicChange} 
                                            />
                                        </div>
                                        </div>
                                    </div>
                                    {(isSelected && !screens.md )  &&(<div style={{paddingBottom:"10px",display:"flex",backgroundColor:"#e5f2f3"}}> 
                                        <ClinicMap  widthAndheight={{ width:!screens.md ? "66px ": 393, height:!screens.md ? "66px ": 393 }}  passData={{
                                  cood: [
                                    {
                                      id: clickedClinicIdItem.id,
                                      name: clickedClinicIdItem.name,
                                      data: [
                                        parseFloat(clickedClinicIdItem.latitude),
                                        parseFloat(clickedClinicIdItem.longitude),
                                      ],
                                    },
                                  ],
                                  name: clickedClinicIdItem.position ?? 'No data',
                                }} />
                                        <div style={{margin:"auto",padding:"0px 10px ",width:"70%",color:"#4A4A4A",overflow:"hidden",maxHeight: "3em",  lineHeight: "1.5em",textOverflow:"ellipsis",textAlign:"left"}}>{stripHtmlTags(a?.clinic_website_description)}</div>
                                    </div>)}
                                    <hr style={{margin:"0"}}/>
                                </>
                            )
                        })}
                    </div>
</div>
                </Col>

                {/* Show map distance when no preferred time is selected AND a default clinic is selected (props.clinicId) OR selectedClinics/selectedClinicsNew has items */}
                {!showPreferredTime && selectedMonth == null && (props?.clinicId || (selectedClinics && selectedClinics.length > 0) || (selectedClinicsNew && selectedClinicsNew.length > 0)) ? <ShowMapDistance /> : <Col  style={{padding:"0px",}}
                xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}>
                    <div style={{ marginTop: 20, }} className="paddingLeft widthOfTitle">
                        <div
                            style={{
                                background: "#00838540",
                                padding: "8.5px 10px",
                                textAlign: "center",
                                fontSize: "20px",
                                fontWeight: "400",
                                color: '#008385',
                                marginTop:"25px", 
                                display: 'flex',
                                justifyContent:screens.md?"center":"start",
                                // marginLeft:"5px"
                            }}
                        >
                            Preferred time:
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 ,textAlign:"left",flexDirection:screens.md?"row":"column",padding:"0px 20px"}}>
                            <div style={{ padding: "0px 0" }}>
                                <Select
                                    defaultValue={currentMonthValue}
                                    style={{ width:90, border: 0 }}
                                    onSelect={handleSelect}
                                    className="antDesignDatepaddingRemove"
                                >
                                    {months.map((month) => (
                                        <Option key={month.value} value={month.value}>
                                            {month.label}
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            <span  style={{color : "rgba(74, 74, 74, 1)" , textAlign:"left"}}>
                                Choose the most convenient time slots to check the availability. You can
                                select more than one time slot.
                            </span>
                        </div>

                        <div style={{ marginTop: 20 ,padding:"0px 20px"}} 
                        >
                            {selectedSlots && showPreferredTimeSlot ? Object.keys(showPreferredTimeSlot)?.map((day, index) => (
                                <div style={{ textAlign: 'left' }} >
                                    <div>{`${moment(day).format('ddd D').toUpperCase()} `}</div>
                                    <div style={{ display: "flex",overflowY:"auto",scrollbarWidth:"thin",paddingBottom:"6px"}} className="my-scroll-container" 
                                    ref={(el) => (elementRefs.current[index] = el) }>
                                        {showPreferredTimeSlot[day].map((slot) => {
                                            return <div
                                                key={slot}
                                                type={selectedSlots.includes(slot) ? "primary" : "default"}
                                                onClick={() => toggleSlot(`${day}${slot.start_time}-${slot.end_time}`, slot, day)}
                                                style={{
                                                    pointerEvents: slot.availablity_status ? 'auto' : 'none',
                                                    minWidth: "93px",
                                                    //  display: "inline-block",               // 👈 Add this to shrink to content
                                                    // width: "auto",   
                                                    color: selectedSlots.includes(`${day}${slot.start_time}-${slot.end_time}`) ? "#008385" : "#000",
                                                    color: slot.availablity_status == 0 ? '#4A4A4A80' : selectedSlots.includes(`${day}${slot.start_time}-${slot.end_time}`) ? "#008385" : "",
                                                    marginTop: 9,
                                                    cursor: 'pointer',
                                                    // padding: '5px 10px',
                                                    // paddingRight: '10px',
                                                    // lineHeight: 1
                                                }}
                                            >
                                                {`${slot.start_time}-${slot.end_time}`}
                                            </div>
                                        })
                                        }
                                    </div>
                                    <hr />
                                </div>
                            )) : loadingTime && <Spin className="custom-spinner" />}
                        </div>
                        {selectedSlots && loadingTime == false && Object.keys(showPreferredTimeSlot).length && metaData?.current_page != metaData?.last_page ? <Button className="bookin-icon" onClick={getLoadMoreData} style={{ border: "none", width: 182, height: 40 }}>
                            {/* Load More down */}
                            <DownOutlined style={{ color: '#008385' }} />
                        </Button> : loadingTime && <Spin className="custom-spinner" />}
                    </div>
                </Col>}
            </Row>
            <Row justify="start" style={{ marginTop: 20 }}>
                {buttonActive && (<div style={{ display: 'flex',marginBottom:"50px",justifyContent:"center",width:"100%",position:"relative" }}>
                    <Button
                        shape="square"
                        icon={<ArrowLeftOutlined style={{ color: '#008385', fontSize: '18px' }} />}
                        style={{
                            backgroundColor: '#C8E6E6', // Light teal
                            border: 'none',
                            width: '40px !important',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: 0,
                            marginRight: 10,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            position:"absolute",
                            left:"10px"
                            
                        }}
                        className="back-button-arrow"
                        onClick={() => props.callBackForbackpage('BookingForm')}
                    />
                    {!showPreferredTime && selectedClinicsNew && <div>
                    <Button type="primary" className="bookin-icon" loading={loading} onClick={appointmentClinicSelection} style={{ background: "#008385", border: "none",  height: 40,margin:"auto",width:"152px",flex:"1" }}>
                        Continue
                    </Button>
                    </div>}
                </div>)}
            </Row>
        </>
    );
};
export default ClinicBooking;
